module.exports = __webpack_public_path__ + "img/154-Skai Woodec Turner Oak.jpg";